import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';
import DeviceData from 'drivers/deviceData';

function getScreen() {
  return httpService.get(ApiUrl.LIVE_SCREEN);
}
function deleteScreen(data) {
  return httpService.deleteReq(ApiUrl.LIVE_SCREEN, data);
}
async function postScreen(data) {
  const device_id = await DeviceData.getUID();
  data.device_id = device_id;
  return httpService.post(ApiUrl.LIVE_SCREEN, data);
}

const obj = { getScreen, deleteScreen, postScreen };

export default obj;
